import React, { useState } from 'react';
import { Button, Typography, DialogTitle, DialogContent, DialogActions } from '@material-ui/core';
import Modal from '../Modal';
import { useStyles } from './styles';

interface ICreditCardDeclinedModal {
  isFcaUser: boolean;
  isAdmin: boolean;
  navigate: (path: string) => void;
  viewFailedTransactions: () => void;
  show: boolean;
  failedTransactions: any;
  onClose?: () => void;
  projectId?: string;
}

export default function CreditCardDeclinedModal({
  isFcaUser,
  isAdmin,
  navigate,
  viewFailedTransactions,
  show,
  failedTransactions,
  onClose,
  projectId,
}: ICreditCardDeclinedModal) {
  const styles = useStyles();

  const onProceed = () => {
    viewFailedTransactions();
    if (onClose) {
      onClose();
    }
    navigate('/payment/settings?highlight=true');
  };

  const close = () => {
    viewFailedTransactions();
    if (onClose) {
      onClose();
    }
    if (failedTransactions && failedTransactions.list) {
      const href = window.location.href;
      const availableList = failedTransactions.list.filter(ft => href.indexOf('projects/detail/' + ft.projectId) >= 0);
      if (availableList && availableList.length > 0) {
        navigate('/');
      }
    }
  };

  return (
    !isFcaUser &&
    show && (
      <Modal
        onClose={onClose}
        show={true}
        styleClass={`${styles.root}`}
        render={() => (
          <>
            <DialogTitle>
              <div className={`${styles.title}`}>Attention!</div>
            </DialogTitle>
            {isAdmin ? (
              failedTransactions &&
              failedTransactions.list &&
              failedTransactions.list.filter(ft => (!projectId || projectId.length < 1 || ft.projectId === projectId) && !ft.invoiceId).length ===
                failedTransactions.list.filter(ft => !projectId || projectId.length < 1 || ft.projectId === projectId).length ? (
                <DialogContent>
                  <Typography className={`${styles.body}`}>Please add a valid credit card to unlock this project.</Typography>
                </DialogContent>
              ) : (
                <DialogContent>
                  <Typography className={`${styles.body}`}>
                    One or more credit cards associated with this account have been recently declined. You have lost access to all projects that have invalid
                    credit card(s) assigned to them. Click Proceed to be redirected to Payment Settings.
                  </Typography>
                  <Typography className={`${styles.body} ${styles.body2}`}>
                    As soon as you update your payment method, the new credit card will be charged the outstanding amount in full. If payment is successful,
                    access to your projects will be restored immediately.
                  </Typography>
                </DialogContent>
              )
            ) : (
              <DialogContent>
                <Typography className={`${styles.body}`}>
                  There is a problem with this account resulting in limited access to your company’s projects. Please contact your supervisor to resolve this
                  issue.
                </Typography>
              </DialogContent>
            )}
            <DialogActions className={isAdmin && styles.actions}>
              <Button color="primary" onClick={close}>
                Close
              </Button>
              {isAdmin &&
                !(
                  failedTransactions &&
                  failedTransactions.list &&
                  failedTransactions.list.filter(ft => (!projectId || projectId.length < 1 || ft.projectId === projectId) && !ft.invoiceId).length ===
                    failedTransactions.list.filter(ft => !projectId || projectId.length < 1 || ft.projectId === projectId).length
                ) && (
                  <Button variant="contained" color="primary" data-testid="proceed-button" onClick={onProceed}>
                    Proceed
                  </Button>
                )}
            </DialogActions>
          </>
        )}
      />
    )
  );
}
